export const ANNOUNCEMENT_JOIN_SESSION = 'ANNOUNCEMENT_JOIN_SESSION';
export const ANNOUNCEMENT_IS_LIVE = 'ANNOUNCEMENT_IS_LIVE';

export const joinLiveAnnouncement = (value) => ({
    type: ANNOUNCEMENT_JOIN_SESSION,
    payload: value,
});

export const setAnnouncementLive = (value) => ({
    type: ANNOUNCEMENT_IS_LIVE,
    payload: value,
});
